import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const PslfProfileSchema = withDefaults({
  type: 'pslf-profile',
  objectExtensions: ['pslf-profile'],
  fields: [
    {
      kind: 'attribute',
      name: 'isInterested',
    },
    {
      kind: 'attribute',
      name: 'ssn',
    },
    {
      kind: 'attribute',
      name: 'signature',
    },
    {
      kind: 'attribute',
      name: 'signaturePresent',
    },
    {
      kind: 'belongsTo',
      name: 'employee',
      type: 'employee',
      options: {
        async: false,
        inverse: 'pslfProfile',
      },
    },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfForms',
      type: 'pslf-form',
      options: {
        async: false,
        inverse: 'pslfProfile',
      },
    },
    {
      kind: 'hasMany',
      name: 'pslfAssets',
      type: 'pslf-asset',
      options: {
        async: false,
        inverse: 'pslfProfiles',
      },
    },
  ],
});

export default PslfProfileSchema;
